import { calcSpacing } from 'src/components/foundations';
import { shadows } from 'src/components/foundations/tokens';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

const CATEGORY_SELECT_TRIGGER_WIDTH_PX = 210;

export const SectionContainer = styled.div<{ $isInitialState?: boolean }>`
  margin-bottom: ${({ $isInitialState }) =>
    $isInitialState ? '0' : `${calcSpacing(2.5)}px`};
`;

export const InitialStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  max-width: 700px;
  width: 100%;
  margin: 0 auto;
  padding: ${calcSpacing(8)}px ${calcSpacing(2)}px;
`;

export const InitialStateIllustration = styled.img`
  width: 160px;
  height: 132px;
  object-fit: contain;
  margin-bottom: ${calcSpacing(2)}px;
`;

export const InitialStateTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${calcSpacing(1)}px;
  text-align: center;
  width: min(700px, 100%);
  margin-bottom: ${calcSpacing(2)}px;
`;

export const InitialStateTitle = styled.h2`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH2)};
  text-align: center;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;

export const InitialStateDescription = styled.p`
  ${(props) => props.theme.newTypography.textStyleBody};
  letter-spacing: 0.2px;
  text-align: center;
  color: ${(props) => props.theme.newPalette.neutral.N800};
  margin: 0;
`;

export const CategorySelectTriggerGroup = styled.div`
  position: relative;
  width: min(${CATEGORY_SELECT_TRIGGER_WIDTH_PX}px, 100%);
  margin: 0 auto;
`;

export const CategoryDropdownWrapper = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  margin-top: ${calcSpacing(0.8)}px;
  z-index: 1000;
  background: ${(props) => props.theme.newPalette.neutral.N0};
  border-radius: 3px;
  box-shadow: ${shadows.sizes.large};
  padding: 0;
  overflow: hidden;
`;

export const CategoryOptionsList = styled.ul<{ $maxVisibleItems?: number }>`
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: ${({ $maxVisibleItems }) =>
    $maxVisibleItems ? `${$maxVisibleItems * 40}px` : 'min(320px, 50vh)'};
  overflow-y: auto;
`;

export const CategoryOptionButton = styled.button<{ $useAtlasStyle?: boolean }>`
  display: block;
  width: 100%;
  margin: 0;
  padding: ${calcSpacing(0.8)}px ${calcSpacing(1)}px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: start;
  ${(props) => props.theme.newTypography.textStyleBody};
  color: ${(props) => props.theme.newPalette.neutral.N800};

  &:hover,
  &:focus-visible {
    background-color: ${(props) =>
      props.$useAtlasStyle
        ? props.theme.atlas.semantic.color.surface.subtle
        : props.theme.newPalette.turquoise.T100};
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.newPalette.turquoise.T300};
    outline-offset: -2px;
  }
`;

export const CategoryOptionsEmpty = styled.p`
  margin: 0;
  padding: ${calcSpacing(0.8)}px ${calcSpacing(1)}px;
  ${(props) => props.theme.newTypography.textStyleBody};
  color: ${(props) => props.theme.newPalette.neutral.N600};
`;
